<template>
  <v-app-bar color="deep-purple accent-4" dense dark fixed>
    <v-btn
      text
      depresed
      rounded
      large
      to="/main"
      tag="li"
      color="deep-green accent-4"
    >
      <v-toolbar-title>შპს "B N M "</v-toolbar-title>
    </v-btn>

    <v-spacer></v-spacer>

    <v-menu left bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list rounded>
        <v-list-item
          v-for="(n, i) in links"
          :key="`${i}-${n.id}`"
          @click="() => {}"
        >
          <router-link :to="n.producerLink">
            <v-list-item-title disabled class="blue--text text--darken-1"
              ><strong>{{ n.producer }}</strong></v-list-item-title
            >
          </router-link>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    links: [
      {
        producer: "მთავარი",
        status: "true",
        producerLink: "/main"
      },
      {
        producer: "TEXOIL",
        status: false,
        producerLink: "#//"
      },
      {
        producer: "SASH",
        status: "true",
        producerLink: "/sash"
      }
    ]
  })
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
